module.exports = __webpack_public_path__ + "img/banner_cfr_test.19ced02c.png";